import { StyledTHeadTr, StyledTBodyTr, StyledTFootTr } from "./Table.styles";

/**
 * A styled `<tr>` component specifically for use inside `<thead>`.
 *
 * Params
 * - children (ReactNode): The header cells to be rendered inside the row.
 * - ...props (any): Additional props passed to the StyledTHeadTr component.
 *
 * Returns
 * - JSX.Element: A styled table row element for the table header.
 */
export const THeadTr = ({ children, ...props }) => {
  return <StyledTHeadTr {...props}>{children}</StyledTHeadTr>;
};

/**
 * A styled `<tr>` component specifically for use inside `<tbody>`.
 *
 * Params
 * - children (ReactNode): The body cells to be rendered inside the row.
 * - ...props (any): Additional props passed to the StyledTBodyTr component.
 *
 * Returns
 * - JSX.Element: A styled table row element for the table body.
 */
export const TBodyTr = ({ children, ...props }) => {
  return <StyledTBodyTr {...props}>{children}</StyledTBodyTr>;
};

/**
 * A styled `<tr>` component specifically for use inside `<tfoot>`.
 *
 * Params
 * - children (ReactNode): The footer cells to be rendered inside the row.
 * - ...props (any): Additional props passed to the StyledTFootTr component.
 *
 * Returns
 * - JSX.Element: A styled table row element for the table footer.
 */
export const TFootTr = ({ children, ...props }) => {
  return <StyledTFootTr {...props}>{children}</StyledTFootTr>;
};
